(function() {
	'use strict';
	angular.module('app.supplyChain')
		.service('shortageCriticalityLevelService', shortageCriticalityLevelService);

	shortageCriticalityLevelService.$inject = ['$http', 'URLS', 'leanFilterService'];
	function shortageCriticalityLevelService($http, URLS, leanFilterService) {
		var shortageCriticalityLevels = {};
		var shortageCriticalityRawLevels = {};
		var criticalityBySites = [];
		var rawCriticalityLevels = [];
		var allLoaded = false;
		var activeLoaded = false;
		// Shortage Criticality rank for None/Non Critical to make it last
		var RANK_FOR_NONE = 9999;
		var RANK_FOR_INACTIVE = 8888;
		return {
			getShortageCriticalityLevels: getShortageCriticalityLevels,
			getShortageCriticalityLevelsGroupByLvl: getShortageCriticalityLevelsGroupByLvl,
			loadCriticalityLevels: loadCriticalityLevels,
			isLoaded: isLoaded,
			getRawCriticalityLevels: getRawCriticalityLevels,
			rankForNone: RANK_FOR_NONE,
			rankForInactive: RANK_FOR_INACTIVE,
			hideCriticalityLevel: hideCriticalityLevel,
			getSelectedSitesCriticalities: getSelectedSitesCriticalities,
			setCriticalityBySites: setCriticalityBySites
		};

		function isLoaded(includeInactive) {
			return includeInactive ? allLoaded: activeLoaded;
		}

		function getShortageCriticalityLevels() {
			return shortageCriticalityLevels;
		}

		function getRawCriticalityLevels() {
			return rawCriticalityLevels;
		}

		function setCriticalityLvls(siteId, levelId, level) {
			if (!shortageCriticalityLevels[siteId]) {
				shortageCriticalityLevels[siteId] = {
					'-1': {
						label: 'None',
						description: 'No criticality level'
					}
				};
			}
			shortageCriticalityLevels[siteId][levelId] = level;
			if (!shortageCriticalityRawLevels[siteId]) {
				shortageCriticalityRawLevels[siteId] = {};
			}
			shortageCriticalityRawLevels[siteId][levelId] = level;
		}

		function loadCriticalityLevels(includeInactive) {
			return $http.get(URLS.host + String.format(URLS.shortageCriticalityLevels, 'LDNA_A_S') + '?fullLevel=true' + (includeInactive ? '&includeInactive=true' : ''))
				.then(loadCriticalityLevelsSuccess)
				.catch(loadCriticalityLevelsFailure);
			
			function loadCriticalityLevelsSuccess(response) {
				if (includeInactive) {
					allLoaded = true;
					activeLoaded = false;
				} else {
					allLoaded = false;
					activeLoaded = true;
				}
				shortageCriticalityLevels = {};
				shortageCriticalityRawLevels = {};
				if (response && response.data) {
					rawCriticalityLevels = response.data;
					response.data.forEach(function(level) {
						if (level.type === 'Customer') {
							var sites = _.map(level.identifierNdx.toString().split(','), function(site) {
								return parseInt(site);
							});
							sites.forEach(function(site) {
								setCriticalityLvls(site, level.id, level);
							});
						} else {
							setCriticalityLvls(level.identifierNdx, level.id, level);
						}
					});
				}
			}

			function loadCriticalityLevelsFailure(error) {
				shortageCriticalityLevels = {};
			}
		}

		function getShortageCriticalityLevelsGroupByLvl(factoryNdxs, includeInactive) {
			factoryNdxs = factoryNdxs || globalConfig.factory.id;
			return $http.get(URLS.host + String.format(URLS.shortageCriticalityLevels, factoryNdxs) + '?fullLevel=true&grouped=true&includeInactive=' + includeInactive)
				.then(loadCriticalityLevelsGroupByLvlSuccess)
				.catch(loadCriticalityLevelsGroupByLvlFailure);

			function loadCriticalityLevelsGroupByLvlSuccess(response) {
				var data;
				if (response && response.data) {
					data = {};
					response.data.forEach(function(level) {
						data[level.label] = level;
					});
				}
				return data;
			}

			function loadCriticalityLevelsGroupByLvlFailure(error) {
				return null;
			}
		}

		function getFactoryIds() {
			var factoryListStr = leanFilterService.getFactoryList();
			var factoryList = [];
			if (!factoryListStr || !factoryListStr.length){
				factoryList = [globalConfig.factory.id.toString()];
			} else {
				factoryList = factoryListStr.split(',');
			}
			return factoryList;
		}

		function hideCriticalityLevel() {
			var siteIds = getFactoryIds();
			var hideLevel = true;
			var criticalityLevels = getShortageCriticalityLevels();
			if (criticalityLevels && _.intersection(siteIds, Object.keys(criticalityLevels)).length) {
				hideLevel = false;
			}
			return hideLevel;
		}

		function setCriticalityBySites() {
			var siteIds = getFactoryIds();
			var criticalityLevels = [];
			angular.forEach(siteIds, function(siteId)  {
				if (shortageCriticalityRawLevels[siteId]) {
					criticalityLevels = criticalityLevels.concat(Object.values(shortageCriticalityRawLevels[siteId]));
				}
			});
			criticalityBySites = criticalityLevels;
		}

		function getSelectedSitesCriticalities() {
			return criticalityBySites;
		}

	}
})();
